import { Component, OnInit } from '@angular/core';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import { EchantillonageService } from 'src/app/services/echantillonage.service';

@Component({
  selector: 'app-iso',
  templateUrl: './iso.component.html',
  styleUrls: ['./iso.component.css']
})
export class IsoComponent implements OnInit {

  echantillonIsoCols : any[] = [
    {field: 'date', header: 'Date estimation'},
    {field: 'nb_estimation', header: 'Nombre estimé'},
    {field: 'nb_echantillons', header: 'Nombre echantillons prévus'},
    {field: 'nb_fiches', header: 'Nombre de fiches échantillonnées'},
  ];
  echantillonsIso : any[] = [];

  ajoutEchantillonageIso : boolean = false;
  estimation : number = 0;
  dateEstimation : Date;
  fr : any;

  constructor(private dateService : DateCalculationService, private echantillonService : EchantillonageService) { }

  ngOnInit(): void {
    this.fr = this.dateService.getFrLocale();

    this.echantillonService.getEchantillonageIso().subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
          this.echantillonsIso = value["data"];
      }
    });
  }


  showAjoutIso() {
    this.ajoutEchantillonageIso = true;
  }

  ajoutEchantillonIso() {
    let date = this.dateService.getEngFormatedDate(new Date()).date;

    let options = {
      nb_estimation : this.estimation,
      date : date
    };
    console.log(options)
    this.echantillonService.insererEchantillonageIso(options).subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        alert("echantillonage ajouté");
        this.ajoutEchantillonageIso = false;
        this.estimation = 0;
        this.dateEstimation = new Date();

        this.echantillonService.getEchantillonageIso().subscribe( value => {
          if(value["status"] !== "success"){
            console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
          } else {
              this.echantillonsIso = value["data"];
          }
        });

      }
    })      
  }


  cancelAjoutIso() {
    this.ajoutEchantillonageIso = false;
  }
  
}
